import { useCallback, useEffect, useState } from "react";
import { trpc } from "../trpc";

export interface ScriptAssistantAccess {
  isAdmin: boolean;
  personaCategoryEnabled: boolean;
  feishuScriptEnabled: boolean;
  atmosphereGroups: string[];
  hasAnyAccess: boolean;
}

const DEFAULT_ACCESS: ScriptAssistantAccess = {
  isAdmin: false,
  personaCategoryEnabled: false,
  feishuScriptEnabled: false,
  atmosphereGroups: [],
  hasAnyAccess: false,
};

export function useScriptAssistantAccess(enabled = true) {
  const [access, setAccess] = useState<ScriptAssistantAccess>(DEFAULT_ACCESS);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!enabled) {
      setAccess(DEFAULT_ACCESS);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await trpc.userAccess.getMyScriptAssistantAccess.query();
      setAccess(data);
    } catch (cause) {
      setAccess(DEFAULT_ACCESS);
      setError(cause instanceof Error ? cause.message : "加载气氛员助手权限失败");
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { access, loading, error, reload };
}
